import {
    ArrayModel,
    ArrayModelFromJson,
    CompositeModel,
    JsonArrayModel,
    TextModel,
    TextModelOptions,
} from '@evorait/pace-core';
import { OdataPISparePartModel } from './pi-spare-part.model';
import {
    OdataPIMeasurementToolModel,
    PIMeasurementToolModel,
    PIMeasurementToolModelFromJson,
} from './pi-measurement-tool.model';
import {
    JsonPISparePartArrayModel,
    PISparePartArrayModel,
    PISparePartArrayModelFromJson,
} from './pi-spare-part-array.model';

export class PhysicalInventoryModel extends CompositeModel {
    public readonly frontId: TextModel;
    public measurementTools: ArrayModel<PIMeasurementToolModel>;
    public materials: PISparePartArrayModel;

    public constructor(data: OdataPhysicalInventoryModel) {
        super('PhysicalInventoryModel', {});

        this.frontId = <TextModel>this.set(new TextModel('FrontId', data.FrontId, new TextModelOptions()));
        this.measurementTools = <ArrayModel<PIMeasurementToolModel>>(
            this.set(new ArrayModel<PIMeasurementToolModel>('PIToolsSet'))
        );
        this.measurementTools.addModels([
            ...data.PIToolsSet.results.map((tool) => PIMeasurementToolModel.fromOdataPIToolsSet(tool)),
        ]);
        this.materials = <PISparePartArrayModel>this.set(new PISparePartArrayModel([...data.SparePartsSet.results]));
    }

    public static fromODataPhysicalInventorySet(data: OdataPhysicalInventoryModel): PhysicalInventoryModel {
        return new PhysicalInventoryModel(data);
    }

    public toJSON(): JsonPhysicalInventoryModel {
        return {
            frontId: this.frontId.value,
            measurementTools: this.measurementTools,
            materials: this.materials,
        };
    }
}

export class PhysicalInventoryModelFromJson extends PhysicalInventoryModel {
    public constructor(data: JsonPhysicalInventoryModel) {
        super({ FrontId: data.frontId, PIToolsSet: { results: [] }, SparePartsSet: { results: [] } });
        this.measurementTools = <ArrayModel<PIMeasurementToolModel>>(
            this.set(new ArrayModelFromJson(PIMeasurementToolModelFromJson, data.measurementTools))
        );
        this.materials = <PISparePartArrayModel>this.set(new PISparePartArrayModelFromJson(data.materials));
    }
}

export interface JsonPhysicalInventoryModel {
    frontId: string;
    measurementTools: JsonArrayModel;
    materials: JsonPISparePartArrayModel;
}

export interface OdataPhysicalInventoryModel {
    PIToolsSet: {
        results: OdataPIMeasurementToolModel[];
    };
    SparePartsSet: {
        results: OdataPISparePartModel[];
    };
    FrontId: string;
}
